import { apiCall } from "./client";

export function getManualNotificationRecipients() {
  return apiCall("/api/system/manual-notification-recipients");
}

export function sendManualNotification(payload) {
  return apiCall("/api/system/manual-notifications", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
